import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AgentCtvRoutingModule} from './agent-ctv-routing.module';
import {AgentCtvComponent} from './agent-ctv.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NzButtonModule, NzDatePickerModule, NzFormModule, NzSelectModule, NzTableModule, NzTagModule, NzToolTipModule} from 'ng-zorro-antd';
import {NzInputModule} from 'ng-zorro-antd/input';
import {CommonModule} from '@angular/common';
import { PopupAcceptAgentComponent } from './popup/popup-accept-agent/popup-accept-agent.component';

@NgModule({
  declarations: [
    AgentCtvComponent,
    PopupAcceptAgentComponent
  ],
    imports: [
        AgentCtvRoutingModule,
        ReactiveFormsModule,
        NzSelectModule,
        NzInputModule,
        NzDatePickerModule,
        CommonModule,
        NzTableModule,
        NzTagModule,
        NzToolTipModule,
        NzButtonModule,
        FormsModule,
        NzFormModule
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [PopupAcceptAgentComponent]
})

export class AgentCtvModule {}
